import { Component, HostBinding, ViewEncapsulation } from '@angular/core';
import { FieldType, FieldTypeConfig } from '@ngx-formly/core';

@Component({
  selector: 'form-input-field',
  standalone: false,
  encapsulation: ViewEncapsulation.None,
  styles: ['.form-input-field { display:flex;  flex: 1;}'],
  template: `
    <p-iftalabel class="flex-1">
      <input
        pInputText
        [formControl]="formControl"
        [formlyAttributes]="field"
        [pTooltip]="
          field.props['translate']
            ? (field.props['tooltip'] || '' | translate)
            : field.props['tooltip']
        "
        tooltipPosition="top"
        class="w-full"
        [placeholder]="
          field.props['translate']
            ? (field.props.placeholder || '' | translate)
            : field.props.placeholder
        "
      />
      <label *ngIf="field.props.label" [htmlFor]="field.id">{{
        field.props['translate']
          ? (field.props.label | translate)
          : field.props.label
      }}</label>
    </p-iftalabel>
  `,
})
export class FormInputFieldType extends FieldType<FieldTypeConfig> {
  @HostBinding('class')
  readonly cssClass = 'form-input-field';
}
